import axios from "axios";
import Qs from "qs";
import store from "../store";

const instance = axios.create({
  baseURL: "/"
});

//请求拦截器
instance.interceptors.request.use((config) => {
  if (config.method === "post") {
    config.data = Qs.stringify(config.data);
  }

  config.headers['Authorization'] = sessionStorage.getItem('token')

  //显示加载中效果
  store.state.loading = true;

  return config;
}), (err) => {
  return Promise.reject(err);
};

//响应拦截器
instance.interceptors.response.use(data => {
  // 响应成功关闭loading
  store.state.loading = false;
  return data
}, error => {
  return Promise.reject(error)
})


export default instance;
